import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: ${(props) => props.customWidth || "auto"};
`;
